/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Carrier_Form_Cod_Summary_Freight_OnlyInputs */

const vi_carrier_form_cod_summary_freight_only = /** @type {(inputs: Carrier_Form_Cod_Summary_Freight_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`= cước ${i?.fee}đ, tiền hàng đã thanh toán`)
};

/**

* @param {Carrier_Form_Cod_Summary_Freight_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_summary_freight_only = /** @type {((inputs: Carrier_Form_Cod_Summary_Freight_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Summary_Freight_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_summary_freight_only(inputs)
});